<template>
  <span class="micad_verticalText">
    {{verticalText}}
  </span>
</template>

<script>
export default {
  name: 'Vertical-text',
  data() {
    return {
        verticalText: "Quisque tristique quis leo vitae luctus.",
        }
    },
};
</script>
